"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ethers_1 = require("ethers");
const networks_1 = require("./configs/networks");
class EkcProvider extends ethers_1.providers.JsonRpcProvider {
    constructor(networkEnum) {
        super(networks_1.NetworkInfo[networkEnum].url);
        this.networkEnum = networkEnum;
    }
}
exports.default = EkcProvider;
